import clsx from "clsx";
import { ShapeProps } from "./types";
import Star8Icon from "@mixitone/icons/star8.svg";

export const Star8: React.FC<ShapeProps> = ({ color, size, className, style, children }) => {
  return (
    <div
      className={clsx("relative flex items-center justify-center", className)}
      aria-roledescription="color dot"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        ...style,
      }}
    >
      <Star8Icon className="absolute inset-0" width={size} height={size} style={{ fill: color }} />
      <span
        className="relative font-bold"
        style={{
          fontSize: `${size / 2}px`,
        }}
      >
        {children}
      </span>
    </div>
  );
};
